<template>

    <m-edit1/>

    <m-forget-password-1 v-bind='{...{"image":null},...{}}' :style='""' class="" ></m-forget-password-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mForgetPassword1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/ForgetPassword/ForgetPassword1';

export default {
    name: 'HomeView',
    components: {mEdit1, mForgetPassword1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
